import _ from 'lodash'
const VIDEO_NATIVE_CONFIG = {
    videos: _.selectAll( '.c-video--native' ),
}
export default VIDEO_NATIVE_CONFIG